
import { Star } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

interface RatingDisplayProps {
  averageRating: number;
  totalReviews?: number;
  showCount?: boolean;
  className?: string;
}

export const RatingDisplay = ({ 
  averageRating, 
  totalReviews, 
  showCount = true, 
  className = "" 
}: RatingDisplayProps) => {
  const { t } = useLanguage();

  const getRatingColorClass = (rating: number) => {
    if (rating <= 2.5) return "bg-rating-low";
    if (rating <= 3.5) return "bg-rating-mid";
    return "bg-rating-high";
  };

  // Create an array of 5 stars with appropriate fill levels
  const renderStars = () => {
    return [1, 2, 3, 4, 5].map((star) => {
      if (averageRating >= star) {
        // Full star
        return <Star key={star} className="fill-yellow-400 text-yellow-400" size={20} />;
      } else if (averageRating > star - 1) {
        // Partial star
        return <Star key={star} className="fill-yellow-400 text-yellow-400" size={20} />;
      } else {
        // Empty star
        return <Star key={star} className="text-gray-300" size={20} />;
      }
    });
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className={`w-8 h-8 flex items-center justify-center rounded-full text-white font-bold ${getRatingColorClass(averageRating)}`}>
        {averageRating.toFixed(1)}
      </span>
      <div className="flex">{renderStars()}</div>
      {showCount && totalReviews !== undefined && (
        <span className="text-sm text-muted-foreground ml-2">
          ({totalReviews} {t('reviews')})
        </span>
      )}
    </div>
  );
};
